import * as React from 'react';
import Avatar from './Avatar';
import { Designer } from './User';

interface Props {
    users: Designer[];
    size: 'extra-small' | 'small';
    limit?: number;
}

const AvatarCollection: React.SFC<Props> = ({ users, size, limit }) => {
    const slicedUsers = limit ? users.slice(0, limit) : users;
    const extraUserCount = users.length - slicedUsers.length;

    return (
        <div className="avatar-collection">
            <span className="avatar-collection__avatars">
                {slicedUsers.map((designer: Designer) => {
                    return (
                        <Avatar
                            key={designer.id}
                            userId={designer.id}
                            variations={[size, 'white-border']}
                        />
                    );
                })}
            </span>
            {extraUserCount > 0 && (
                <span className="avatar-collection__suffix">+{extraUserCount}</span>
            )}
        </div>
    );
};

export default AvatarCollection;
